/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export const modalStyles = css`
  div.TCPModal__InnerContent {
    @media ${(props) => props.theme.mediaQuery.large} {
      max-width: 810px;
    }
  }
  .alignRight.alignRight {
    right: 25px;
  }

  .alignTop.alignTop {
    top: 38px;
  }
`;

export default css`
  .pjp-gift-logo {
    @media ${(props) => props.theme.mediaQuery.medium} {
      img {
        width: 80px;
        height: 26px;
      }
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      height: 41px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .brand-image {
    width: 70px;
    height: 28px;
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      padding-top: 6px;
      width: 50px;
      height: 30px;
    }
  }

  .shortDesc {
    font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    padding-top: 0;
    padding-bottom: 0px;
    margin-left: 0;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }

  .longDescSection {
    margin-left: 0;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    width: 75%;
  }
  .gift-header {
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      font-family: ${(props) => props.theme.fonts.tertiaryUrbaneBold};
    }
  }
  .checkbox-header {
    width: 100%;
    display: flex;
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      position: relative;
    }

    .title {
      align-items: center;
      padding-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
      margin-left: 4px;
      &.no-visile {
        position: static;
        font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy5}px;
        font-weight: ${(props) => props.theme.fonts.fontWeight.semiBold};
        border: 0;
      }
      @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
        position: absolute;
        padding: ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0;
        top: -10px;
        border: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
        border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
      }
    }
    .title::after {
      content: '';
      border: 1px solid ${(props) => props.theme.colorPalette.gray[800]};
      border-width: 0 ${(props) => props.theme.spacing.ELEM_SPACING.XXXS}
        ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} 0;
      margin-top: 1px;
      padding: 5px;
      transform: rotate(315deg);
      position: absolute;
      right: 20px;

      ${(props) =>
        props.spc
          ? `
        @media ${props.theme.mediaQuery.medium} {
          display: none;
        }
      `
          : ''}
    }
    .title .no-visile::after {
      display: none;
    }
  }

  .TextBox__input {
    border: 1px solid ${(props) => props.theme.colors.FOOTER.DIVIDER};
    height: 146px;
    padding: 0;
    width: 99%;
  }
  .addReceipt {
    padding-top: '10px';
    margin-left: 0;
  }
  .giftServicesContainer {
    background: ${(props) => props.theme.colors.PRIMARY.PALEGRAY};
    border-radius: 12px;
    overflow: hidden;
    margin-left: 0;
    justify-content: center;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 16px;
      padding-bottom: 0;
    }
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    @media ${(props) => props.theme.mediaQuery.medium} {
      justify-content: left;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    }
    .giftService-Header {
      width: 100%;
      padding: 22px;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        padding: 22px 11px;
      }
      margin-bottom: 6px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-bottom: 22px;
        padding: 0;
      }
    }
  }
  .messageTextWrapper {
    margin-top: ${(props) => props.theme.spacing.LAYOUT_SPACING.XS};
    padding-bottom: 6px;
  }
  .priceDropdown {
    margin-left: 120px;
  }
  .giftServicesField {
    display: inline-block;
    width: auto;
    .CheckBox__text {
      padding-top: 6px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      width: 100%;
      .checkBoxLabelAlign {
        ${(props) =>
          !props.isShowGsOnBagSection
            ? `width: 100%;
        background: transparent;`
            : ''}
      }
    }
    &.no-visile {
      display: none;
    }
  }
  .edit-form-css {
    width: 100%;
  }
  .gift-service-option-card {
    max-width: 365px;
    padding-bottom: 10px;
    min-height: 100px;
    margin: 8px 0;
    border-radius: 6px;
    border: solid 2px #ffffff;
    @media (max-width: ${(props) => props.theme.breakpoints.medium}) {
      padding-top: 10px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      min-height: auto;
    }
  }
  .active-gift-card {
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.12);
    border: solid 2px ${(props) => props.theme.colors.BRAND.PRIMARY};
  }
  .dropdownliBottomBorder {
    cursor: pointer;
    margin-left: 0;
    margin-right: 0;
    padding: ${(props) =>
      `${props.theme.spacing.ELEM_SPACING.XS} ${props.theme.spacing.ELEM_SPACING.MED}`};
    border-bottom: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
    > div {
      height: 100%;
    }
  }
  .dropdownUlBorder li:last-child {
    .dropdownliBottomBorder {
      border: 0;
    }
  }
  .price {
    float: right;
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
  }
  .longDesc {
    font-size: ${(props) => props.theme.typography.fontSizes.fs12};
  }
  .giftServicesDetailsLink {
    text-decoration: underline;
    cursor: pointer;
    padding-top: 6px;
  }
  .phone-field-wrapper {
    width: 20%;
    margin-bottom: -8px;
    border-radius: 8px;
    padding-right: 0;
    display: flex;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: auto;
      padding: 16px;
      height: 38px;
    }
    align-self: center;
    @media (min-width: ${(props) => props.theme.breakpoints.smallMax}) {
      margin-right: 0 !important;
    }
    margin-right: ${(props) => (!props.spc ? props.theme.spacing.ELEM_SPACING.LRG : '')};
  }
  .phone-field-wrapper label {
    margin: 0 3px;
    padding: 6px;
    padding-bottom: 8px;
  }
  .gift-brand-wrapper-snj {
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      display: flex;
      justify-content: center;
    }
  }
  .isBrandTabSelected {
    background: ${(props) => props.theme.colors.WHITE};
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px,
      rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px,
      rgba(0, 0, 0, 0.09) 0px -3px 5px;
    display: flex;
  }

  @media ${(props) => props.theme.mediaQuery.smallMax} {
    .gift-brand-wrapper-tcp {
      margin-right: 20px;
    }
    .gift-brand-wrapper-gym {
      margin-left: 0;
      margin-right: 12px;
    }
    .gift-brand-wrapper-snj {
      margin-right: 20px;
    }
    .gift-brand-wrapper-pjp {
      margin-left: 0;
      margin-right: 0;
    }
    .brand-image-tcp,
    .brand-image-gym {
      width: 70px;
    }
    .brand-image-snj {
      width: 50px;
    }
    .brand-image-pjp {
      width: 90px;
    }
  }

  .snj-label-radio {
    height: 45px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: 35px;
    }
  }
  @media ${(props) => props.theme.mediaQuery.medium} {
    .gym-radio-button,
    .tcp-radio-button {
      padding-top: 10px;
    }
    .pjp-radio-button {
      padding-top: 13px;
    }
  }
  .snj-radio-button {
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding-top: 2px;
    }
  }
  .radio-button,
  .radio-button-checked {
    top: 10px;
    height: 20px;
    width: 20px;
  }

  .radio-button-checked {
    &::after {
      top: 5px;
      left: 5px;
    }
  }

  .phone-field-wrapper .radio-button,
  .phone-field-wrapper .radio-button-checked {
    display: none;
  }
  .normal-select-box {
    padding-top: 5px;
  }

  .custom-select {
    width: 100%;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    > span {
      display: none;
    }
  }
  .giftServicesModal {
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 90%;
    }
  }
  .customSelectTitle {
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy3}px;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    cursor: pointer;
    .customSelectArrow {
      top: 52%;
      right: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
      cursor: pointer;
    }
    .price {
      margin-right: 22px;
    }
  }
  .edit-form-css > div {
    @media (min-width: 768px) {
      width: 48% !important;
      margin-right: 0;
    }
  }
  .dropdownDivOverFlow {
    overflow-y: visible;
    div {
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    }
    .dropdownUlBorder {
      width: auto;
      border: 1px solid ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      border-radius: ${(props) =>
        `0 0 ${props.theme.spacing.ELEM_SPACING.XS_6} ${props.theme.spacing.ELEM_SPACING.XS_6}`};
      @media ${(props) => props.theme.mediaQuery.large} {
        height: auto;
      }
    }
    .dropdownActiveClass {
      background-color: ${(props) => props.theme.colors.PRIMARY.LIGHTGRAY};
      div {
        color: ${(props) => props.theme.colors.PRIMARY.DARK};
        font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      }
      span {
        font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      }
      .dropdownActiveIcon {
        display: none;
      }
    }
  }
  .dropdownListWrapper .dropdownDivOverFlow {
    max-height: 210px;
  }
  .gymImage {
    @media ${(props) => props.theme.mediaQuery.small} {
      margin-top: 8px;
    }
  }
  .gift-message {
    width: 100%;
    height: ${(props) => props.theme.spacing.LAYOUT_SPACING.XL};
    resize: none;
    font-size: ${(props) => props.theme.fonts.fontSize.textbox_input}px;
    overflow-y: hidden;
    box-sizing: border-box;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    ${(props) =>
      `border: 1px solid ${props.theme.colors.PRIMARY.LIGHTGRAY};
    border-radius: ${props.theme.spacing.ELEM_SPACING.XS_6};
    font-family: ${props.theme.fonts.secondaryFontFamily};
    outline:0;
    `}
  }
  .CheckBox__input {
    margin-right: 0;
  }

  .mobile-title {
    .price {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XXXL};
    }
  }

  div.TCPModal__InnerContent {
    top: 70%;
    padding: ${(props) =>
      `${props.theme.spacing.ELEM_SPACING.LRG} ${props.theme.spacing.ELEM_SPACING.MED}`};
    overflow: scroll;
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
    @media ${(props) => props.theme.mediaQuery.large} {
      max-width: 810px;
    }
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      top: 58%;
      @media (max-height: 1067px) {
        height: 85vh;
      }
      @media (min-height: 1067px) {
        height: 86vh;
      }
    }

    .gc-save-button {
      padding: 12px 64px;
      letter-spacing: 0.769px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        border-radius: 6px;
      }
    }
  }
  .alignRight.alignRight {
    right: 16px;
  }

  .alignTop.alignTop {
    top: 47px;
  }

  .spc-gift-service-option-container {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      width: 75%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .spc-gift-service-option-price {
    @media ${(props) => props.theme.mediaQuery.smallMax} {
      position: absolute;
      right: 10%;
    }
  }
  .giftservice-content {
    display: flex;
  }
  .giftservice-content-image {
    height: 82px;
    padding-left: 10px;
  }

  ${(props) =>
    props.isGcEnabledOnBagSection
      ? `
      @media ${props.theme.mediaQuery.mediumMax} {
    margin-bottom: 0;
  }
  .gift-service-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 0;
    border-radius: 0px 0px 12px 12px;
    background: #f4faff;
  }
  .gift-service-header-image {
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap;
    .header-icon {
      padding-left: 0;
    }
  }
  .giftServicesField {
    width: auto;
    .Checkbox__error {
      display: none;
    }
    .checkBoxLabelAlign {
      background: #f4faff;
      .indicator,
      .indicator-text {
        display: none;
      }
      .CheckBox__text {
        cursor: pointer;
      }
    }
  }
  .gift-service-selected-text {
    display: flex;
    font-size: 12px;
    font-weight: 500;
  }
  .mixed-cart-warning-wrapper {
    padding-top: 10px;
    font-style: italic;
  }
  .gc-warning-text {
    font-weight: 500;
  }
  `
      : ''}
  div.TCPModal__InnerContent.gift-services-modal {
    max-width: 100%;
    top: 110px;
    border-radius: 8px 8px 0px 0px;
    right: 0;
    transform: none;
    height: calc(100% - 96px);
    left: unset;
    overflow-x: hidden;
    padding: 0;
    @media ${(props) => props.theme.mediaQuery.medium} {
      max-width: 375px;
      border-radius: 0;
      top: 0;
      height: 100%;
    }
    .Modal_Heading {
      display: block;
      text-align: center;
      padding: 15px 18px;
      margin: 0;
      color: ${(props) => props.theme.colorPalette.gray[900]};
      font-family: Nunito;
      font-size: 16px;
      font-weight: 700;
      border-bottom: 1px solid #e6e6e6;
      background: ${(props) => props.theme.colors.CULTURED};
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 12px 16px;
      }
    }
    .alignTop.alignTop {
      top: 9px;
    }
    .giftServicesContainer {
      margin: 0px 16px 32px 16px;
      padding: 2px;
      width: calc(100% - 36px);
      gap: 4px;
      justify-content: space-between;
    }
    .gc-full-width {
      justify-content: flex-start;
    }
    .edit-form-css {
      width: calc(100% - 32px);
      flex-direction: column;
      padding: 0 16px;
    }
    .gs-radio-btn-wrapper {
      gap: 32px;
    }
    .edit-form-css > div {
      @media ${(props) => props.theme.mediaQuery.medium} {
        width: 100% !important;
        margin-right: 0;
      }
    }
    .gift-service-option-card {
      min-height: 0px;
    }
    .giftService-Header {
      padding: 20px 16px 16px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        padding: 16px;
      }
    }
    .button-wrapper {
      width: calc(100% - 36px);
      padding: 18px;
      margin-top: 24px;
      position: sticky;
      bottom: 0px;
      background: ${(props) => props.theme.colors.WHITE};
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: 28px;
        position: relative;
        padding-top: 0;
      }
      @media (min-height: 875px) and ${(props) => props.theme.mediaQuery.xlarge} {
        position: absolute;
      }
    }
    .absolute-position {
      @media ${(props) => props.theme.mediaQuery.medium} {
        position: absolute;
      }
    }
    .messageTextWrapper {
      width: calc(100% - 32px);
      padding: 0 16px;
      margin-top: 32px;
      margin-bottom: 12px;
    }
    .add-message-text {
      width: 50%;
      margin: 0;
    }
    .phone-field-wrapper {
      padding: 0;
      margin: 0;
      border-radius: 10px;
      width: 24%;
    }
    .phone-field-wrapper label {
      margin: 0 auto;
    }
    .radio-button,
    .radio-button-checked {
      left: 0px;
      top: 0px;
      height: 19px;
      width: 19px;
    }
    .giftservice-heading {
      line-height: 20px;
      color: ${(props) => props.theme.colors.BLACK};
    }
    .giftservice-price {
      color: ${(props) => props.theme.colors.BLACK};
      font-weight: 800;
    }
    .giftservice-content-text {
      font-size: 14px;
      line-height: 21px;
      color: ${(props) => props.theme.colors.BLACK};
    }
    .gift-service-option-card,
    .active-gift-card {
      padding: 0 0 0 33px;
      margin: 0;
      border: none;
      box-shadow: none;
    }
    .radio-button-checked {
      &::after {
        top: 4px;
        left: 4px;
        width: 11px;
        height: 11px;
      }
    }
    .gift-message {
      height: 119px;
    }
    .giftservice-note {
      width: calc(100% - 32px);
      padding: 0 16px;
      margin-top: 32px;
    }
    .tcp-radio-button {
      padding: 7px 9px;
    }
    .isBrandTabSelected {
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.12);
    }
    .giftservice-content-image {
      height: 70px;
    }
    .container {
      margin: 16px 16px 0;
    }
    .sub-heading {
      flex-direction: column;
    }
  }
`;
